import React from 'react';
import Modal, { ModalSize } from './Modal';
import Button, { ButtonVariant } from './Button';
import Spinner from './Spinner';

interface ConfirmModalProps {
  title?: string;
  message: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: ButtonVariant;
  size?: ModalSize;
  onConfirm: () => void;
  onCancel: () => void;
  confirming?: boolean;
}

const spinnerForegroundByVariant: Record<ButtonVariant, string> = {
  primary: 'text-primary-foreground',
  secondary: 'text-secondary-foreground',
  danger: 'text-destructive-foreground',
  outline: 'text-foreground',
  'brand-outline': 'text-primary',
  ghost: 'text-foreground',
};

export default function ConfirmModal({
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'primary',
  size = 'sm',
  onConfirm,
  onCancel,
  confirming,
}: ConfirmModalProps) {
  return (
    <Modal size={size} onClick={confirming ? undefined : onCancel} closeButtonCLick={confirming ? undefined : onCancel} modalClassName="p-6">
      {title && (
        <h2 className="text-lg font-semibold text-foreground font-inter mb-2">{title}</h2>
      )}
      <div className="text-sm text-muted-foreground font-inter mb-6">{message}</div>
      <div className="flex items-center justify-end gap-3">
        <Button type="button" variant="outline" onClick={onCancel} disabled={confirming}>
          {cancelLabel}
        </Button>
        <Button type="button" variant={variant} onClick={onConfirm} disabled={confirming}>
          {confirming ? <Spinner size="sm" className={spinnerForegroundByVariant[variant]} /> : confirmLabel}
        </Button>
      </div>
    </Modal>
  );
}
